import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BehaviorSubject, filter, interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PwaUpdateService {
  private updateAvailable$ = new BehaviorSubject<boolean>(false);
  private swUpdate = inject(SwUpdate);
  
  constructor() {
    if (this.swUpdate.isEnabled) {
      // Check for updates on app initialization
      this.checkForUpdate();
      
      // Check for updates every 30 minutes
      interval(30 * 60 * 1000).subscribe(() => this.checkForUpdate());
      
      // Listen for version updates
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          this.updateAvailable$.next(true);
        });
        
      // Handle unrecoverable state
      this.swUpdate.unrecoverable.subscribe(event => {
        console.error('An error occurred that we cannot recover from:', event.reason);
        // Force reload to get latest version
        window.location.reload();
      });
    }
  }
  
  get updateAvailable() {
    return this.updateAvailable$.asObservable();
  }
  
  checkForUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }
  
  activateUpdate() {
    this.swUpdate.activateUpdate().then(() => {
      window.location.reload();
    });
  }
  
  // Force check for updates (useful for testing)
  forceUpdateCheck() {
    if (this.swUpdate.isEnabled) {
      console.log('Forcing update check...');
      return this.swUpdate.checkForUpdate();
    }
    return Promise.resolve(false);
  }
}